import { CorrespondenceMethodEnum, CountryCodeEnum } from '../../../../../types/forms';
import { CompanyDetailsFormModel_OB_FP } from './formModel';

export const getInitialValues = (): CompanyDetailsFormModel_OB_FP => {
  return {
    identityType: undefined,
    identityNumber: undefined,
    croNumber: undefined,
    registeredPartnershipName: undefined,
    entityForm: undefined,
    businessType: undefined,
    businessSubType: undefined,
    institutionalType: undefined,
    enterpriseSize: undefined,
    telephoneType: undefined,
    countryCode: CountryCodeEnum.Ireland,
    correspondenceMethod: CorrespondenceMethodEnum.email,
    dateOfIncorporation: undefined,
    vatNumber: undefined,
    annualProfitCurrentYear: undefined,
    annualProfitPreviousYear: undefined,
    currentBusinessContracts: undefined,
    businessHistory: undefined,
    phoneNumber: undefined,
    companyEmail: undefined,
    contactFirstName: undefined,
    contactLastName: undefined,
    contactPosition: undefined,
    contactCountryCode: CountryCodeEnum.Ireland,
    contactPhoneNumber: undefined,
  };
};
